export default "__VITE_ASSET__Bf89bIpl__"